/**
 * After detail-panel collapse, auto-height + pinned columns can leave stale
 * virtualizer positions (blank rows until scroll). Recalculate once expand
 * state has settled — controlled mode applies IDs on the next commit.
 */
import type { GridApiPro } from "@mui/x-data-grid-pro";
import type { MutableRefObject } from "react";

export function scheduleResetRowHeightsAfterDetailCollapse(
  apiRef: MutableRefObject<GridApiPro>,
  isSettled: () => boolean
): void {
  const tryResetRowHeights = () => {
    if (isSettled()) {
      apiRef.current.resetRowHeights();
      return true;
    }
    return false;
  };

  if (!tryResetRowHeights()) {
    requestAnimationFrame(() => {
      if (!tryResetRowHeights()) {
        requestAnimationFrame(tryResetRowHeights);
      }
    });
  }
}
